var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 90,
    viewBox: "0 0 98 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_101_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5363 19.4849C14.3697 14.6931 18.1026 10.2747 23.1489 10.2747H74.8567C79.9031 10.2747 83.636 14.6931 83.4693 19.4849C83.309 24.0875 83.5171 30.05 85.0176 34.9115C86.523 39.7883 89.0613 42.8701 93.2188 43.2667V47.7575C89.0613 48.1541 86.523 51.2359 85.0176 56.1128C83.5171 60.9742 83.309 66.9367 83.4693 71.5393C83.636 76.3311 79.9031 80.7489 74.8567 80.7489H23.1489C18.1026 80.7489 14.3697 76.3304 14.5363 71.5393C14.6967 66.9367 14.4885 60.9742 12.9874 56.1128C11.4827 51.2366 8.93736 48.1541 4.77979 47.7575V43.2667C8.93736 42.8708 11.4827 39.7883 12.9874 34.9115C14.4885 30.05 14.696 24.0875 14.5363 19.4849Z",
    fill: "url(#paint0_linear_101_87)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_101_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1866 64.5021C59.3562 64.5021 64.2792 60.502 64.2792 53.9043C64.2792 48.9171 60.7665 45.3065 55.5508 44.7349V44.5271C59.3828 43.9038 62.3898 40.3452 62.3898 36.371C62.3898 30.7084 57.9192 27.0198 51.1068 27.0198H35.7787V64.5021H51.1866ZM41.7397 31.7733H49.6698C53.9808 31.7733 56.4289 33.6954 56.4289 37.1761C56.4289 40.8907 53.5817 42.9686 48.4191 42.9686H41.7397V31.7733ZM41.7397 59.7486V47.4103H49.6165C55.258 47.4103 58.1852 49.4883 58.1852 53.5405C58.1852 57.5926 55.338 59.7486 49.9624 59.7486H41.7397Z",
    fill: "url(#paint1_linear_101_87)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_101_87",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_87",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_101_87",
    x: 33.0151,
    y: 24.947,
    width: 34.0278,
    height: 43.0098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.690919
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38184
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_87",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_87",
    x1: 17.9216,
    y1: 12.1398,
    x2: 95.201,
    y2: 73.4851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9013FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6610F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_87",
    x1: 38.4754,
    y1: 29.4864,
    x2: 55.7484,
    y2: 58.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E5FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.6086f27ba98100fc6f5d29604285e416.svg";
export { ForwardRef as ReactComponent };